import { BreakthroughFuelHold } from "../BreakthroughFuelHold";
import { BreakthroughFuelReady } from "../BreakthroughFuelReady";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutBreakthroughFuelList extends Layout {
    horizontalspacer2: HorizontalSpacer;
    labelProcessing: Label;
    layoutHold: BreakthroughFuelHold;
    layoutReady: BreakthroughFuelReady;
    panelBreakthroughHeader: Panel;
    panelHeader: Panel;
    sourceBreakthroughTransaction: DataSource;
    tabHold: Tab;
    tabReady: Tab;
    tabsetMain: Tabset;
}
